export default class Theme {
    static currThemeIndex = window.config.THEME_INDEX ?? 0;
    static colors = window.config.COLORS ??
        [
            ['#fefefe', '#003366', '#ff6527', '#f4f4f4', 'black'], // 0
        ]
    static cols() { return Theme.colors[Theme.currThemeIndex] }
    static col0(c) { return Theme.currThemeIndex < 0 ? c : Theme.colors[Theme.currThemeIndex][0] }
    static col1(c) { return Theme.currThemeIndex < 0 ? c : Theme.colors[Theme.currThemeIndex][1] }
    static col2(c) { return Theme.currThemeIndex < 0 ? c : Theme.colors[Theme.currThemeIndex][2] }
    static col3(c) { return Theme.currThemeIndex < 0 ? c : Theme.colors[Theme.currThemeIndex][3] }
    static col4(c) { return Theme.currThemeIndex < 0 ? c : Theme.colors[Theme.currThemeIndex][4] }
    static SetNext() {
        if (Theme.currThemeIndex < Theme.colors.length - 1)
            Theme.currThemeIndex++;
        else
            Theme.currThemeIndex = -1;
    }
}